module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "outpfm1"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "Outlaws with Badges display type.tif",
      "src": "Images/OutlawswithBadgesd_fmt1.jpeg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "PELOGO.TIF",
      "src": "Images/PELOGO_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("PELICAN PUBLISHING COMPANY")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v("Gretna 2013")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5046ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 63
// module chunks = 0